import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import SingleButton from '../../form/form-control-buttons/SingleButton/SingleButton';
import T, { t } from '../../../common/components/T';
import { LangContext } from '../../../common/decorators/Language';
import UserContext from '../../../common/utils/getContext';
import { useWidgetTranslates } from '../../../common/utils/utils';
import { getGeoName } from '../../../common/utils/memo';
import css from './RegionAndCurrencySwitcherConfirm.module.scss';
import classnames from 'classnames';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';

const RegionAndCurrencySwitcherConfirm = ({ styles, mode, setIsShowPortalModal, setIsShowConfirmModal, blockRef }) => {
    const { translation } = useContext(LangContext);
    const { localization, lang, setState, activeLangs } = useContext(UserContext) || {};
    const [geoname, setGeoname] = useState({
        country: localization?.country?.code
    });
    const trans = useWidgetTranslates('SiteSettings');
    useEffect(() => {
        if (localization.country?.id) {
            getGeoName(localization.country?.id, lang).then((res) => {
                setGeoname(res.data);
            });
        }
    }, [lang, localization, localization?.country?.id]);

    const requestLanguage = useMemo(
        () =>
            activeLangs &&
            (activeLangs?.find((language) => language.alias === localization?.country?.language) ||
                activeLangs?.find((language) => language.isDefault) ||
                null),
        [activeLangs, localization?.country?.language]
    );

    const triangleRef = useRef();
    const width = useWindowDimensions();

    const buttons = useMemo(
        () => [
            {
                type: 'cancel',
                buttonText: t('no', 'Нет', 'all', translation),
                clickFunc: () => {
                    setIsShowConfirmModal(false);
                    setIsShowPortalModal(true);
                }
            },
            {
                type: 'ok',
                buttonText: t('yes', 'Да', 'all', translation),
                clickFunc: () => {
                    setIsShowConfirmModal(false);
                    const newLang = requestLanguage.alias;
                    if (!!localization && typeof localization === 'object') {
                        if (newLang) {
                            setState('localization', { ...localization, language: requestLanguage.alias });
                        } else {
                            setState('localization', localization);
                        }
                    }
                    if (newLang) {
                        if (lang !== newLang) {
                            setState('lang', newLang);
                        }
                    }
                }
            }
        ],
        [lang, localization, requestLanguage?.alias, setIsShowConfirmModal, setIsShowPortalModal, setState, translation]
    );

    useEffect(() => {
        if (blockRef?.current && triangleRef?.current) {
            const block = blockRef.current;
            const triangle = triangleRef.current;

            const blockPos = block.getBoundingClientRect();
            triangle.style.right = blockPos.width / 2 + 'px';
            triangle.style.left = 'unset';
        }
    }, [blockRef?.current, triangleRef?.current, width]);

    return (
        <div className={classnames(css.dropDownWrapper, mode === 'left' ? css.dropDownWrapperLeft : null)}>
            <div ref={triangleRef} className={css.triangleDropdown} />
            <div className={css.dropDown}>
                <div className={css.dropDownText}>
                    <T
                        customTranslates={trans}
                        textName='SiteSettings-dropDownText-1'
                        defaultStr='Мы определили ваш регион, как ${country}.'
                        vars={{ country: geoname?.name }}
                        page='widget'
                        group='SiteSettings'
                    />
                    <br />
                    <T
                        customTranslates={trans}
                        textName='SiteSettings-dropDownText-3'
                        defaultStr='Использовать язык - ${language}?'
                        vars={{ language: requestLanguage.name }}
                        page='widget'
                        group='SiteSettings'
                    />
                    <div className={css.dropDownBtnsWrapper}>
                        {buttons.map((item, idx) => (
                            <SingleButton
                                key={`button${idx}`}
                                customStyles={styles}
                                type={item.type}
                                clickFunc={item.clickFunc}
                                buttonText={item.buttonText}
                                customButton={{
                                    butWrapper: css.button
                                }}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default RegionAndCurrencySwitcherConfirm;
